import React from "react";
import styles from '../../css/Part10.module.css';

function AppointmentPage() {
  return (
    <main className={styles.appointmentPage}>
      <section className={styles.heroSection}>
        <img 
          src="images/background/corporate.png" 
          className={styles.backgroundImage} 
          alt="Appointment"
        />
        <div className={styles.contentWrapper}>
          <div className={styles.twoColumnLayout}>
            <div className={styles.leftColumn}>
              <div className={styles.ctaWrapper}>
                <h2>Contact Us</h2>
                <p>Still have questions? No worries!</p>
                <p>Select a time to schedule a one-to-one session with us and learn more about the Foneplus program.</p>
                <button 
                  className={styles.ctaButton} onClick={() => window.open('https://calendly.com/natalieliau-forestone/45min?month=2024-10', '_blank')}>Book An Appointment
                </button>
              </div>
            </div>
            <div className={styles.rightColumn}>
              <img 
                src="images/background/foneplus-schedule.png" 
                className={styles.featureImage} 
                alt="appointment booking"
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AppointmentPage;